/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const mainVisSwiper = () => {
		const splide = new Splide('.top-mainVis.splide', {
			type: 'fade',
			perPage: 1,
			autoplay: true,
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			rewind: true,
		}).mount();

		// 一時停止/再生ボタンの制御
		const playPauseBtn = document.querySelector('.splide__play-pause');
		const stopIcon = playPauseBtn?.querySelector('.stop-icon');
		const playIcon = playPauseBtn?.querySelector('.play-icon');
		let isPlaying = true;

		if (playPauseBtn && stopIcon && playIcon) {
			// 初期状態：再生中なのでstopアイコンを表示
			stopIcon.style.display = 'block';
			playIcon.style.display = 'none';

			playPauseBtn.addEventListener('click', () => {
				if (isPlaying) {
					// 一時停止
					splide.Components.Autoplay.pause();
					stopIcon.style.display = 'none';
					playIcon.style.display = 'block';
					playPauseBtn.setAttribute('aria-label', 'スライドショーを再生');
					isPlaying = false;
				} else {
					// 再生
					splide.Components.Autoplay.play();
					stopIcon.style.display = 'block';
					playIcon.style.display = 'none';
					playPauseBtn.setAttribute('aria-label', 'スライドショーを一時停止');
					isPlaying = true;
				}
			});
		}
	};

	const newsAccordion = () => {
		const accordionBtn = document.querySelector('.top-news .__accordion');
		const contents = document.querySelector('.top-news .__contents');
		
		if (accordionBtn && contents) {
			accordionBtn.addEventListener('click', () => {
				contents.classList.toggle('is-active');
				accordionBtn.classList.toggle('is-active');
			});
		}
	};

	const styleSlider = () => {
        const styleSliderElement = document.getElementById('style-slider');
        if (!styleSliderElement) return;
        
        const slides = Array.from(document.querySelectorAll('.style-slide'));
        const paginationDots = Array.from(document.querySelectorAll('.style-pagination-dot'));
        if (slides.length === 0) return;
        
        let currentIndex = 2; // 中央が初期位置
        
        // スワイプ・ドラッグ用の変数
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;
        let isPointerDown = false;
        let startTime = 0;
        let hasMoved = false;
        
        // 添付画像と同じ配置になるよう計算
        function calculatePositions() {
            const containerWidth = window.innerWidth;
            let gap, slideWidth, slideHeight;
            
            if (containerWidth <= 1024) {
                // SP時：274pxの正方形、16px間隔
                gap = 16;
                slideWidth = 274;
                slideHeight = 274;
            } else {
                // PC時：5枚が収まるよう成り行きで計算、24px間隔、最小320px
                gap = 24;
                const calculatedWidth = (containerWidth - gap * 4) / 5; // 5枚分の幅を画面幅から計算
                slideWidth = Math.max(calculatedWidth, 320); // 最小320px
                slideHeight = Math.floor(slideWidth * 1.3);
            }
            
            // 5枚の画像を間隔で中央配置
            const totalContentWidth = slideWidth * 5 + gap * 4; // 5枚分 + 4つの間隔
            const leftStartX = (containerWidth - totalContentWidth) / 2;
            
            if (containerWidth <= 1024) {
                return [
                    // 左端
                    { x: leftStartX, y: 65, width: slideWidth, height: slideHeight },
                    // 左
                    { x: leftStartX + slideWidth + gap, y: 32, width: slideWidth, height: slideHeight },
                    // 中央（メイン）
                    { x: leftStartX + (slideWidth + gap) * 2, y: 0, width: slideWidth, height: slideHeight },
                    // 右
                    { x: leftStartX + (slideWidth + gap) * 3, y: 65, width: slideWidth, height: slideHeight },
                    // 右端
                    { x: leftStartX + (slideWidth + gap) * 4, y: 32, width: slideWidth, height: slideHeight }
                ];
            } else {
                return [
                    // 左端
                    { x: leftStartX, y: 135, width: slideWidth, height: slideHeight },
                    // 左
                    { x: leftStartX + slideWidth + gap, y: 67, width: slideWidth, height: slideHeight },
                    // 中央（メイン）
                    { x: leftStartX + (slideWidth + gap) * 2, y: 0, width: slideWidth, height: slideHeight },
                    // 右
                    { x: leftStartX + (slideWidth + gap) * 3, y: 135, width: slideWidth, height: slideHeight },
                    // 右端
                    { x: leftStartX + (slideWidth + gap) * 4, y: 67, width: slideWidth, height: slideHeight }
                ];
            }
        }
        
        function applyPositions() {
            const positions = calculatePositions();
            const slideHeight = positions[0].height;
            const containerWidth = window.innerWidth;
            const additionalHeight = containerWidth <= 1024 ? 40 : 160;
            const containerHeight = slideHeight + additionalHeight;
            
            // コンテナの高さを設定
            const container = document.querySelector('.style-slider-container');
            if (container) {
                container.style.height = `${containerHeight}px`;
            }
            
            slides.forEach((slide, i) => {
                const pos = positions[i];
                slide.style.left = `${pos.x}px`;
                slide.style.top = `${pos.y}px`;
                slide.style.width = `${pos.width}px`;
                slide.style.height = `${pos.height}px`;
            });
        }
        
        function updatePagination() {
            paginationDots.forEach((dot, index) => {
                dot.classList.toggle('is-active', index === currentIndex);
            });
        }
        
        function rotateRight() {
            const slide = slides.pop();
            slides.unshift(slide);
            currentIndex = (currentIndex + 1) % slides.length;
            
            const positions = calculatePositions();
            const slideWidth = positions[0].width;
            
            // 即座に左端外に移動
            slide.style.transition = 'none';
            slide.style.left = `${-slideWidth}px`;
            slide.style.top = '50px';
            slide.style.width = `${slideWidth}px`;
            slide.style.height = `${positions[0].height}px`;
            
            requestAnimationFrame(() => {
                slide.offsetHeight;
                slide.style.transition = 'all 0.6s ease';
                applyPositions();
                updatePagination();
            });
        }
        
        function rotateLeft() {
            const slide = slides.shift();
            slides.push(slide);
            currentIndex = (currentIndex - 1 + slides.length) % slides.length;
            
            const positions = calculatePositions();
            const slideWidth = positions[0].width;
            
            // 即座に右端外に移動
            slide.style.transition = 'none';
            slide.style.left = `${window.innerWidth}px`;
            slide.style.top = '50px';
            slide.style.width = `${slideWidth}px`;
            slide.style.height = `${positions[0].height}px`;
            
            requestAnimationFrame(() => {
                slide.offsetHeight;
                slide.style.transition = 'all 0.6s ease';
                applyPositions();
                updatePagination();
            });
        }
        
        // スワイプ・ドラッグ関数
        function handlePointerStart(e) {
            isPointerDown = true;
            hasMoved = false;
            startTime = Date.now();
            
            if (e.type === 'touchstart') {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
            } else {
                startX = e.clientX;
                startY = e.clientY;
                e.preventDefault(); // PCでの選択を防ぐ
            }
            
            currentX = startX;
            currentY = startY;
        }
        
        function handlePointerMove(e) {
            if (!isPointerDown) return;
            
            if (e.type === 'touchmove') {
                currentX = e.touches[0].clientX;
                currentY = e.touches[0].clientY;
            } else {
                currentX = e.clientX;
                currentY = e.clientY;
            }
            
            const deltaX = currentX - startX;
            const deltaY = currentY - startY;
            
            // 移動量が一定以上の場合、移動フラグを立てる
            if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
                hasMoved = true;
            }
        }
        
        function handlePointerEnd(e) {
            if (!isPointerDown) return;
            isPointerDown = false;
            
            const deltaX = currentX - startX;
            const deltaY = currentY - startY;
            const deltaTime = Date.now() - startTime;
            
            // 縦方向のスクロールを優先（縦の移動量が横より大きい場合はスワイプ判定しない）
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
                return;
            }
            
            // スワイプ判定の閾値
            const minSwipeDistance = 50; // 最小スワイプ距離
            const maxSwipeTime = 800; // 最大スワイプ時間（ミリ秒）
            
            if (Math.abs(deltaX) > minSwipeDistance && deltaTime < maxSwipeTime && hasMoved) {
                if (deltaX > 0) {
                    // 右スワイプ（前のスライドへ）
                    rotateRight();
                } else {
                    // 左スワイプ（次のスライドへ）
                    rotateLeft();
                }
            }
        }
        
        function handlePointerCancel() {
            isPointerDown = false;
            hasMoved = false;
        }
        
        // リサイズ時の位置調整
        window.addEventListener('resize', applyPositions);
        
        // イベントリスナー設定
        const rightArrow = document.querySelector('.style-arrow.right');
        const leftArrow = document.querySelector('.style-arrow.left');
        const container = document.querySelector('.style-slider-container');
        
        if (rightArrow) rightArrow.addEventListener('click', rotateRight);
        if (leftArrow) leftArrow.addEventListener('click', rotateLeft);
        
        // スワイプ・ドラッグイベントリスナー
        if (container) {
            // タッチイベント（スマートフォン・タブレット）
            container.addEventListener('touchstart', handlePointerStart, { passive: true });
            container.addEventListener('touchmove', handlePointerMove, { passive: true });
            container.addEventListener('touchend', handlePointerEnd, { passive: true });
            container.addEventListener('touchcancel', handlePointerCancel, { passive: true });
            
            // マウスイベント（PC）
            container.addEventListener('mousedown', handlePointerStart);
            container.addEventListener('mousemove', handlePointerMove);
            container.addEventListener('mouseup', handlePointerEnd);
            container.addEventListener('mouseleave', handlePointerCancel);
            
            // ドラッグを無効化（画像のドラッグ防止）
            container.addEventListener('dragstart', (e) => e.preventDefault());
            
            // 選択を無効化
            container.style.userSelect = 'none';
            container.style.webkitUserSelect = 'none';
            container.style.msTouchAction = 'pan-y pinch-zoom';
            container.style.touchAction = 'pan-y pinch-zoom';
        }
        
        // インジケータークリックイベント
        paginationDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                const diff = index - currentIndex;
                if (diff === 0) return;
                
                if (diff > 0) {
                    for (let i = 0; i < diff; i++) {
                        rotateRight();
                    }
                } else {
                    for (let i = 0; i < Math.abs(diff); i++) {
                        rotateLeft();
                    }
                }
            });
        });
        
        // 自動再生
        let autoplayInterval = setInterval(rotateLeft, 4000);
        
        // ホバー時に自動再生停止
        styleSliderElement.addEventListener('mouseenter', () => {
            clearInterval(autoplayInterval);
        });
        
        styleSliderElement.addEventListener('mouseleave', () => {
            autoplayInterval = setInterval(rotateLeft, 4000);
        });
        
        // 初期位置設定
        applyPositions();
        updatePagination();
    };

	const pickupSwiper = () => {
		const splide = new Splide('.top-pickup-slider.splide', {
			type: 'loop',
			perPage: 3,
			perMove: 1,
			clones: 3,
			gap: '40px',
			autoplay: true,
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			breakpoints: {
				1024: {
					perPage: 1.3,
					gap: '20px',
					focus: 'center', // 中央表示を維持
				},
			},
		}).mount();
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		mainVisSwiper();
		newsAccordion();
		styleSlider();
		pickupSwiper();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
